export const NETWORK_MIN_INPUT_DELAY_TICKS = 3;
export const NETWORK_MAX_INPUT_DELAY_TICKS = 9;
export const NETWORK_LATENCY_PROBE_SAMPLES = 3;
export const NETWORK_LATENCY_PROBE_TIMEOUT_MS = 1_500;
export const NETWORK_RECONNECT_DEADLINE_MS = 15_000;

/**
 * Selects one deterministic input window for both peers before tick zero.
 * Half of RTT approximates one-way delay; the extra margin absorbs jitter.
 */
export function networkInputDelayTicks(roundTripMs: number | null, tickRate: number): number {
  if (roundTripMs === null || !Number.isFinite(roundTripMs) || roundTripMs < 0 || !Number.isFinite(tickRate) || tickRate <= 0) return NETWORK_MAX_INPUT_DELAY_TICKS;
  const oneWayWithJitterMarginMs = roundTripMs / 2 + 75;
  return Math.max(NETWORK_MIN_INPUT_DELAY_TICKS, Math.min(NETWORK_MAX_INPUT_DELAY_TICKS, Math.ceil(oneWayWithJitterMarginMs / (1_000 / tickRate))));
}
